import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';
import withEndpointAuthorization from '../../../units/authorization/withEndPointAuthorization';
import { PUT } from '../../../../config/permissions';
import { EXECUTE_SEAT_RELEASE_ENDPOINT } from '../../../../config/endpoints';

const SeatReleasePermissionsButton = ({ selectedIds, handleRelease }) => (
  <Button
    color="danger"
    block
    disabled={selectedIds.length === 0}
    onClick={handleRelease}
  >
    {selectedIds.length > 0
      ? `Liberar ${selectedIds.length} asiento${
          selectedIds.length !== 1 ? 's' : ''
        }`
      : 'Liberar seleccionados'}
  </Button>
);

SeatReleasePermissionsButton.propTypes = {
  selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleRelease: PropTypes.func.isRequired,
};

export default withEndpointAuthorization({
  url: EXECUTE_SEAT_RELEASE_ENDPOINT,
  permissionType: PUT,
})(SeatReleasePermissionsButton);
